import sys from '@truckdown/jsclient';
import * as locations from '@truckdown/locations';
import * as icons from '@truckdown/jsclient/icons';

import { defineComponent, ref, computed, reactive } from 'vue';

sys.fontLibrary.add(icons.solid.faClock);

export default defineComponent({
    props: {
        listing: {
            type: Object as () => locations.Listing,
            required: true
        }
    },
    setup: function (props, ctx) {
        let listing = props.listing as locations.Listing;

        const convertTime = function (time: string) {
            var components = time.split(':');
            if (components.length == 2) {
                var hour = Number(components[0]);
                if (!isNaN(hour)) {
                    if (hour >= 12) {
                        let suffix = ':' + components[1] + ' PM';
                        if (hour == 12) {
                            return hour + suffix
                        }
                        //pm
                        return ((hour - 12) < 10 ? '0' : '') + (hour - 12) + suffix;
                    } else {
                        if (time == '00:00') {
                            return '12:00 AM';
                        }
                        return time + ' AM';
                    }
                }
            }

            return time;
        }

        const getTimeFromEntry = function (entry: locations.HoursEntryModel) {
            var entries: string[] = [];
            if (entry.enabled) {
                for (let i = 0; i < entry.entries.length; i++) {

                    if (entry.entries[i].type == locations.HoursOfOperationDisplayType.Open
                        || (entry.entries[i].type == locations.HoursOfOperationDisplayType.AfterHours
                            && !entry.afterHours24)) {

                        //add entry
                        var hourValue = convertTime(entry.entries[i].startTime) + ' to ' + convertTime(entry.entries[i].endTime);
                        if (entry.entries[i].type == locations.HoursOfOperationDisplayType.AfterHours) {
                            if (!listing.properties.mobileOnly && !listing.properties.managedService) {
                                hourValue = hourValue + ' (road service)';
                            } else {
                                hourValue = hourValue + ' (emergency service)';
                            }
                        };
                        entries.push(hourValue);
                    }
                }
            }

            if (entries.length > 0) {
                return entries.join('<br>');
            }
            return 'Closed';
        }

        const getTimeEntry = function (day: string) {
            if (listing.hoursData.type == locations.HoursOfOperationType.Closed) {
                return 'Closed';
            }
            if (listing.hoursData.type == locations.HoursOfOperationType.AlwaysOpen) {
                return 'Open 24hrs';
            }
            if (listing.hoursData.type == locations.HoursOfOperationType.SelectHours) {
                var entry = listing.hoursData.entries[day];
                if (entry) {
                    return getTimeFromEntry(entry);
                }

                return 'Unknown';
            }
            return 'Unknown';
        }

        const getTimeEntryMessage = function (day: string) {
            if (listing.hoursData.type == locations.HoursOfOperationType.SelectHours) {
                var entry = listing.hoursData.entries[day];
                if (entry) {
                    if (entry.enabled && entry.afterHours24) {
                        if (!listing.properties.mobileOnly && !listing.properties.managedService) {
                            return '24 hours road service';
                        } else {
                            return '24 hours emergency service';
                        }
                    }
                }

                return '';
            }
            return '';
        }

        return {
            getTimeEntry,
            getTimeEntryMessage
        };
    }
});
